/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import Copilot from '@camunda/feel-copilot-client';

import { openAiService, tracingService } from 'services';

class FeelCopilotClient {
  static _invoke = async ({ input, signal }) => {
    let response;
    try {
      response = await openAiService.createFeelCopilotChatCompletion(input, signal);
    } catch (error) {
      if (!signal.aborted) {
        const message = 'Call to FEEL Copilot service failed';
        console.error(message);
        tracingService.traceError(error, message);
      }
      return Promise.reject(error);
    }

    return response;
  };
  static client;

  /**
   *
   * @param String prompt
   * @returns {import('@camunda/feel-copilot-client').InvokeResponse}
   */
  callFeelCopilot = ({ prompt, variables, context, expression }) => {
    if (!FeelCopilotClient.client) {
      FeelCopilotClient.client = new Copilot({ invoke: FeelCopilotClient._invoke });
    }

    return FeelCopilotClient.client.invoke({ context, expression, prompt, variablesFromDiagram: variables });
  };

  isResponseSuccessful = (response) => {
    return response.status === 'success';
  };

  wasInputTooLong = (response) => {
    return response.status === 'inputTooLong';
  };

  wasResponseCancelled = (response) => {
    return response.status === 'cancelled';
  };
}

export const feelCopilotClient = new FeelCopilotClient();
